import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62a13388"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-more" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Element hinzufügen")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Weitere Optionen", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "keyboard_arrow_down", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "advanced-content"
}
const _hoisted_7 = { class: "user-input" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Erwartet Nutzereingabe nach diesem Block")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_flow_panel_element_text = _resolveComponent("flow-panel-element-text")!
  const _component_flow_panel_element_buttons = _resolveComponent("flow-panel-element-buttons")!
  const _component_VueDraggableNext = _resolveComponent("VueDraggableNext")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_checkbox = _resolveComponent("md-checkbox")!
  const _component_md_card = _resolveComponent("md-card")!
  const _component_FlowPanelBlockElementsList = _resolveComponent("FlowPanelBlockElementsList")!
  const _component_transition_fade = _resolveComponent("transition-fade")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_VueDraggableNext, {
      list: _ctx.block.elements,
      handle: ".drag"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.block.elements, (element, k) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "element",
            key: k
          }, [
            (element.type == 'text')
              ? (_openBlock(), _createBlock(_component_flow_panel_element_text, {
                  key: 0,
                  modelValue: _ctx.block.elements[k],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.block.elements[k]) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
              : (element.type == 'buttons')
                ? (_openBlock(), _createBlock(_component_flow_panel_element_buttons, {
                    key: 1,
                    modelValue: _ctx.block.elements[k],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.block.elements[k]) = $event),
                    onOverlay: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('overlay', $event)))
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["list"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_md_button, {
        variant: "outlined",
        icon: "add_circle",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleElements(true)))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_md_card, {
      variant: "outlined",
      class: "advanced",
      clickable: !_ctx.showAdvanced,
      onClick: _ctx.expandAdvancedSection
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["advanced-header", { expanded: _ctx.showAdvanced }]),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.collapseAdvancedSection && _ctx.collapseAdvancedSection(...args)))
        }, _hoisted_5, 2),
        (_ctx.showAdvanced)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_md_checkbox, {
                  modelValue: _ctx.userInput,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userInput) = $event))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["clickable", "onClick"]),
    _createVNode(_component_transition_fade, null, {
      default: _withCtx(() => [
        (_ctx.showElementsList)
          ? (_openBlock(), _createBlock(_component_FlowPanelBlockElementsList, {
              key: 0,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleElements(false))),
              onClick: _ctx.addElement
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}